import { axiosInstance } from "./";

const ADMIN_COMPANY_CLIENTS_PATH = "/company_clients";

/** GET /api/admin_portal/v2/company_clients — list company clients (scoped by company). */
const getAdminCompanyClients = (params = {}, config = {}) =>
  axiosInstance.get(ADMIN_COMPANY_CLIENTS_PATH, { ...config, params });

/** GET /api/admin_portal/v2/company_clients/:id — show one company client. */
const getAdminCompanyClient = (id) =>
  axiosInstance.get(`${ADMIN_COMPANY_CLIENTS_PATH}/${id}`);

/** POST /api/admin_portal/v2/company_clients — invite or link a client. */
const createAdminCompanyClient = (data) =>
  axiosInstance.post(ADMIN_COMPANY_CLIENTS_PATH, data);

/** PATCH /api/admin_portal/v2/company_clients/:id — update relationship fields. */
const updateAdminCompanyClient = ({ id, data }) =>
  axiosInstance.patch(`${ADMIN_COMPANY_CLIENTS_PATH}/${id}`, data);

export {
  getAdminCompanyClients,
  getAdminCompanyClient,
  createAdminCompanyClient,
  updateAdminCompanyClient,
};
